<template>
  <div :class="{'station-furnace-batch-bar': true, 'batch-bar-expired': isExpired && isLoadingBedEmpty && !isInGracePeriod && isBatchSet, 'batch-bar-notset': !isBatchSet}" @click.prevent="$emit('click')">
    <template v-if="isBatchSet && isExpired && !isInGracePeriod && isLoadingBedEmpty">
      <i class="far fa-clock"></i> Toughening Batch Expired. Click here to start a new batch
    </template>
    <template v-else-if="!isBatchSet">
      <i class="far fa-exclamation-circle"></i> No Toughening Batch Set. Click here to start a new batch
    </template>
    <template v-else>
      <span class="batch-bar-title">Current Batch:</span><span class="batch-bar-value">#{{tougheningBatch.sequenceNumber}}</span>
      <span class="batch-bar-title">Thickness:</span><span class="batch-bar-value">{{tougheningBatch.batchThickness}}mm</span>
      <span class="batch-bar-title">Type:</span><span class="batch-bar-value">{{formatLookupName(tougheningBatch.complianceType, ToughenBatchComplianceTypeLookup)}}</span>
      <template v-if="!isComplianceAutomotive">
        <span class="batch-bar-title">Glass:</span><span class="batch-bar-value">{{formatLookupName(tougheningBatch.glassType, ToughenBatchGlassTypeLookup)}}</span>
      </template>
      <template v-if="isComplianceAutomotive">
        <span class="batch-bar-title">Lumen:</span><span class="batch-bar-value">{{formatLookupName(tougheningBatch.lumenTransType, ToughenBatchLumenTransTypeLookup)}}</span>
      </template>
      <span class="batch-bar-title">Particle Count:</span><span class="batch-bar-value">{{tougheningBatch.batchParticleCount}}</span>
      <span class="batch-bar-title">Timer:</span>
      <span v-if="!isExpired" :class="{'batch-bar-value': true, 'batch-bar-value-warning': isTimerWarning}">{{activeBatchTimeRemaining}} mins</span>
      <span v-if="isExpired && isInGracePeriod" :class="{'batch-bar-value': true, 'batch-bar-value-warning': isTimerWarning}">Expired. Last Scan In</span>
      <span v-if="isExpired && !isInGracePeriod" :class="{'batch-bar-value': true, 'batch-bar-value-warning': isTimerWarning}">Expired</span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.station-furnace-batch-bar {
  top: 0;
  left: 0;
  right: 0;
  padding: 6px;
  background-color: #2F5075;
  border-bottom: 1px solid #38618f;
  color: #FFFFFF;
  font-size: 1.0rem;
  font-weight: normal;
  cursor: pointer;
}
.batch-bar-expired {
  background-color: #9b3b3b;
  border-bottom: 1px solid #c55e5e;
}
.batch-bar-notset {
  background-color: #2b4868;
  border-bottom: 1px solid #193b63;
}
.batch-bar-title {
  color: #c5e2fc;
  margin-right: 5px;
}
.batch-bar-value {
  color: #FFFFFF;  
  margin-right: 14px;
}
.batch-bar-value-warning {
  color: #ED5565;
}
</style>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { AccountSettingKeys, ToughenBatchComplianceTypes, ToughenBatchComplianceTypeLookup, ToughenBatchGlassTypes, ToughenBatchGlassTypeLookup, ToughenBatchLumenTransTypes, ToughenBatchLumenTransTypeLookup } from '@/store/types'

export default {
  name: 'TougheningBatchBar',
  props: {
    tougheningBatch: Object,
    loadingBedPanelCount: Number
  },
  data() {
    return {
      activeBatchTimeRemaining: 0,
      isExpired: false,
      isInGracePeriod: false,
    }
  },
  created() {
    this.ToughenBatchComplianceTypeLookup = ToughenBatchComplianceTypeLookup
    this.ToughenBatchGlassTypeLookup = ToughenBatchGlassTypeLookup
    this.ToughenBatchLumenTransTypeLookup = ToughenBatchLumenTransTypeLookup
  },
  mounted() {
    this.updateBatchTimer()
    this.$options.batchTimerInterval = setInterval(this.updateBatchTimer, 1000)
  },
  beforeDestroy () {
    clearInterval(this.$options.batchTimerInterval)
  },
  computed: {
    ...mapState({
      accountSettings: state => state.account.accountSettings
    }),
    isLoadingBedEmpty() {
      return this.loadingBedPanelCount == 0
    },
    isBatchSet() {
      return this.tougheningBatch != null
    },
    isTimerWarning() {
      let minutesWarning = 5    // 5 minutes warning

      return this.activeBatchTimeRemaining <= minutesWarning
    },
    isComplianceAutomotive() {
      if(!this.tougheningBatch)
        return false
      return this.tougheningBatch.complianceType == ToughenBatchComplianceTypes.automotive
    },
    batchExpiryGraceTime() {
      if(!this.accountSettings)
        return false

      return parseInt(this.accountSettings[AccountSettingKeys.productionTougheningBatchGraceTime] || 0)
    }
  },
  methods: {
    updateBatchTimer() {
      if(this.tougheningBatch) {
        this.activeBatchTimeRemaining = Math.round(moment.duration(moment(this.tougheningBatch.expiryTime).diff(moment())).asMinutes())
        this.isExpired = moment().isAfter(moment(this.tougheningBatch.expiryTime))
        this.isInGracePeriod = false
        
        if(this.isExpired && this.batchExpiryGraceTime > 0) {
          let gracePeriodEnd = moment(this.tougheningBatch.expiryTime).add(this.batchExpiryGraceTime, 'minutes')
          if(moment().isBefore(gracePeriodEnd)) {
            this.isInGracePeriod = true
          }
        }
      } else {
        this.activeBatchTimeRemaining = 0
        this.isExpired = false
        this.isInGracePeriod = false
      }
    }
  }
}
</script>